module.exports = __webpack_public_path__ + "img/1728612118653-Screenshot 2024-10-11 095439.png.497d8ff0.webp";